/* global window */
'use strict';

const { breakpoints, breakpointHeights } = require('../lib/constants.js');

module.exports = {
    get: function () {
        let breakpoint;
        const width = window.innerWidth;
        const height = window.innerHeight || 0;
        for (let possibleBreakpoint in breakpoints) {
            if (width >= breakpoints[possibleBreakpoint]) {
                if (
                    !breakpointHeights[possibleBreakpoint] ||
                    height >= breakpointHeights[possibleBreakpoint]
                ) {
                    breakpoint = possibleBreakpoint;
                }
            }
        }
        return breakpoint;
    },
};
